export enum ServiceType {
  WORKER = "worker",
  APPS = "apps",
}

export enum MaintenanceType {
  SQS_MISSING = "sqs_missing",
}
